import { confirmDialog } from 'primereact/confirmdialog';

export default confirmDialog;
